(function(){
  var modal = document.getElementById('swQuote');
  if(!modal) return;
  var form = document.getElementById('swForm');
  var errBox = document.getElementById('swErr');
  var WA_NUM = (window.FASTCO_WA || '5215500000000');

  function abrir(v){ modal.classList.toggle('open', v); modal.setAttribute('aria-hidden', v?'false':'true'); document.documentElement.style.overflow = v?'hidden':''; if(v){ setTimeout(function(){ var f=form.querySelector('select,input'); if(f) f.focus(); },140); } }
  ['swQuoteOpen','swQuoteOpen2'].forEach(function(id){ var b=document.getElementById(id); if(b) b.addEventListener('click', function(){ abrir(true); }); });
  modal.querySelectorAll('[data-swq-close]').forEach(function(x){ x.addEventListener('click', function(){ abrir(false); }); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && modal.classList.contains('open')) abrir(false); });

  function folio(){ var d=new Date(); var p=function(n){return ('0'+n).slice(-2);}; return 'SW-'+d.getFullYear().toString().slice(-2)+p(d.getMonth()+1)+p(d.getDate())+'-'+p(d.getHours())+p(d.getMinutes())+p(Math.floor(Math.random()*90)+10); }

  function genPDF(data, f){
    if(!(window.jspdf && window.jspdf.jsPDF)) return null;
    var doc = new window.jspdf.jsPDF({unit:'pt', format:'a4'});
    var W = doc.internal.pageSize.getWidth();
    var M = 48, y = 0;
    doc.setFillColor(226,51,0); doc.rect(0,0,W,84,'F');
    doc.setTextColor(255,255,255); doc.setFont('helvetica','bold'); doc.setFontSize(24);
    doc.text('fastco', M, 45); doc.setTextColor(255,220,210); doc.text('.', M+70, 45);
    doc.setFontSize(11); doc.setFont('helvetica','normal'); doc.setTextColor(255,255,255);
    doc.text('Solicitud de cotizacion de software', M, 66);
    doc.setFontSize(10); doc.text('Folio ' + f, W-M, 45, {align:'right'});
    var fecha = new Date().toLocaleDateString('es-MX',{day:'2-digit',month:'long',year:'numeric'});
    doc.text(fecha, W-M, 66, {align:'right'});
    y = 120;
    doc.setTextColor(10,10,10); doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.text('Sistema solicitado', M, y); y+=8;
    doc.setDrawColor(226,51,0); doc.setLineWidth(2); doc.line(M,y,M+150,y); y+=22;
    doc.setFont('helvetica','bold'); doc.setFontSize(16); doc.setTextColor(226,51,0);
    doc.text(data.tipo || '-', M, y); y+=30;
    doc.setTextColor(10,10,10); doc.setFont('helvetica','bold'); doc.setFontSize(13);
    doc.text('Datos de la compania', M, y); y+=8;
    doc.line(M,y,M+150,y); y+=20;
    var rows = [['Compania', data.empresa],['Giro', data.giro],['Contacto', data.nombre],['Cargo', data.cargo],['Telefono', data.telefono],['Correo', data.correo],['Sitio web', data.sitio || '-'],['Pais', data.pais],['Ciudad', data.ciudad]];
    doc.setFontSize(11);
    rows.forEach(function(r){
      doc.setFont('helvetica','bold'); doc.setTextColor(90,90,90); doc.text(r[0], M, y);
      doc.setFont('helvetica','normal'); doc.setTextColor(10,10,10); doc.text(String(r[1]||'-'), M+120, y);
      y+=20;
    });
    if(data.detalle){
      y+=6; doc.setFont('helvetica','bold'); doc.setTextColor(90,90,90); doc.text('Detalles', M, y); y+=16;
      doc.setFont('helvetica','normal'); doc.setTextColor(10,10,10);
      var lines = doc.splitTextToSize(data.detalle, W-M*2); doc.text(lines, M, y); y+= lines.length*15 + 6;
    }
    y = Math.max(y, doc.internal.pageSize.getHeight()-120);
    doc.setDrawColor(230,224,216); doc.setLineWidth(1); doc.line(M,y,W-M,y); y+=18;
    doc.setFont('helvetica','bold'); doc.setFontSize(11); doc.setTextColor(10,10,10);
    doc.text('Proximo paso', M, y); y+=15;
    doc.setFont('helvetica','normal'); doc.setFontSize(10); doc.setTextColor(90,90,90);
    doc.text('Un especialista de Fastco Software le contactara para agendar una demostracion de 20 minutos', M, y); y+=13;
    doc.text('y presentar una propuesta con licencia mensual a la medida de su operacion.', M, y); y+=22;
    doc.setTextColor(150,150,150); doc.setFontSize(9);
    doc.text('FASTCO - Parte del grupo Brainstore Mexico - fastco.mx', M, y);
    return doc;
  }

  form.addEventListener('submit', function(ev){
    ev.preventDefault();
    errBox.hidden = true;
    var fd = new FormData(form); var data = {};
    fd.forEach(function(v,k){ data[k] = (v||'').toString().trim(); });
    var req = ['tipo','giro','empresa','nombre','cargo','telefono','correo','pais','ciudad'];
    for(var i=0;i<req.length;i++){ if(!data[req[i]]){ errBox.hidden=false; form.querySelector('[name="'+req[i]+'"]').focus(); return; } }
    var f = folio();
    // El envio es automatico: PDF + correo. WhatsApp queda como opcion en la pantalla de gracias.
    var doc = genPDF(data, f);
    if(doc){
      var fn = 'Cotizacion-'+f+'.pdf';
      try{ doc.save(fn); }catch(e){}
    }
    try{
      if(window.FASTCO_SW_ENDPOINT){
        var enviarWorker = function(pdfB64){
          fetch(window.FASTCO_SW_ENDPOINT, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({folio:f, data:data, pdf:pdfB64})}).catch(function(){});
        };
        if(doc){
          try{
            var b64full = doc.output('datauristring');
            var b64 = b64full.substring(b64full.indexOf(',')+1);
            enviarWorker(b64);
          }catch(e){ enviarWorker(null); }
        } else {
          enviarWorker(null);
        }
      }
    }catch(e){}
    // Pantalla de exito: oculta el formulario y muestra agradecimiento
    var panel = modal.querySelector('.swq-panel');
    var waOk = 'https://wa.me/'+WA_NUM+'?text='+encodeURIComponent('Hola, FastcoMX, acabo de enviar una solicitud de cotizacion de software (folio '+f+') desde su pagina web y quiero dar seguimiento.');
    panel.innerHTML =
      '<div class="swq-done">'+
        '<span class="swq-done-ic"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6 9 17l-5-5"/></svg></span>'+
        '<h3>¡Gracias! Su requerimiento ha sido enviado con éxito</h3>'+
        '<p>Recibimos su solicitud con folio <b>'+f+'</b> y la enviamos a nuestro equipo. Un especialista de Fastco Software le contactará a la brevedad.</p>'+
        '<div class="swq-done-btns">'+
          '<a class="btn btn-solid swq-done-wa" href="'+waOk+'" target="_blank" rel="noopener"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M21 12a8.5 8.5 0 0 1-12.4 7.5L4 21l1.6-4.4A8.5 8.5 0 1 1 21 12z"/></svg> Contactar por WhatsApp</a>'+
          '<a class="btn btn-ghost swq-done-home" href="/">Cerrar y volver al inicio</a>'+
        '</div>'+
      '</div>';
  });
})();
